export default {
  siteId: 'rei',
  templateType: 'checkout',
  contentType: 'commerce',

  checkoutType: {
    paypalExpress: 'Paypal Express',
    applePayExpress: 'Apple Pay Express',
    guest: 'Guest Checkout',
    signedInWithAddress: 'Signed in – address stored',
    signedInNoAddress: 'Signed in – no stored info',
  },

  event: {
    checkout: 'checkout',
  },

  generateLinkText({ pageDescription, linkText }) { return `${this.templateType}:${pageDescription}_${linkText}` },

  link: {
    // Order summary section
    toggleSavings: (page, savingsVisible) => `${page}_summary_${savingsVisible ? 'hide' : 'show'} savings`,
    estimatedUserDividend: page => `${page}_est. coop reward earned displayed`,
    totalSavingsDisplayed: page => `${page}_you save message displayed`,

    // Gift Options Modal
    // eslint-disable-next-line no-confusing-arrow
    toggleGiftReceipt: (page, includeReciept) => includeReciept ?
      `${page}_gift options_include gift receipt` :
      `${page}_gift options_no gift receipt`,
    giftOptionsSave: (page, isEdit) => `${page}_${isEdit ? 'edit' : 'select'} gift options_save`,
    giftOptionsCancel: (page, isEdit) => `${page}_${isEdit ? 'edit' : 'select'} gift options_cancel`,
    giftOptionsClose: (page, isEdit) => `${page}_${isEdit ? 'edit' : 'select'} gift options_close`,
    giftOptionsClear: page => `${page}_gift options_clear message`,

    // Membership page
    attachMembershipUsingPhoneNumber: 'checkout:membership_attach membership_using phone number',
    attachMembershipUsingMemberId: 'checkout:membership_attach membership_using member number',
    learnMoreAboutMembership: 'checkout:membership_learn more',
    addMembershipToCart: 'checkout:membership_add membership',
    removeMembershipFromCart: 'checkout:membership_remove membership',
    navigateForwardNoMembership: 'checkout:membership_continue_without membership',
    navigateForwardWithMembership: 'checkout:membership_continue',
    useMemberNumberForMemberLookup: 'checkout:membership_use member number',
    usePhoneNumberForMemberLookup: 'checkout:membership_use phone number',
    verifyMembership: 'checkout:membership_verify membership_using member number',
    cancelVerifyMembership: 'checkout:membership_verify membership_using member number_cancel',
    membershipDividendEligibility: 'checkout:membership_dividend eligibility',
    membershipAttachedDividendEligibility: 'checkout:membership_attached_dividend eligibility',
    membershipDividend: 'checkout:membership_member dividend',
    membershipContactPhone: 'checkout:membership_contact_phone',
    membershipContactLiveChat: 'checkout:membership_contact_live chat',
    membershipSignIn: 'checkout:membership_sign in',
    membershipCreateAccount: 'checkout:membership_create-account',
    membershipLinkYourMembership: 'checkout:membership_link_your_membership',
    attachMembershipMismatchError: 'The information you gave us doesn\'t match our records.',
    membershipForgotMemberNumber: 'checkout:membership_forgot member number',

    // Members only modal
    membersOnlyModal: (action, pageName) => {
      const actionMap = {
        open: 'open',
        already: 'no rei member',
        add: 'yes add membership',
        remove: 'no remove membership',
        continue: 'continue',
        callForHelp: 'call scs',
      }

      return `${pageName}_membermodal_${actionMap[action]}`
    },

    // Unavailable items modal
    unavailableModal: 'checkout:out of stock',
    unavailableEditInCart: 'checkout:out of stock_edit in cart',
    unavailableRemoveFromOrder: 'checkout:out of stock_remove from order',

    // Billing address page
    submitBillingAddress: 'checkout:billing_continue',

    // Contact info page
    submitContactInfo: 'checkout:contact info_continue',

    // Contact and billing page
    submitContactAndBilling: 'checkout:contact and billing_continue',

    // Items to Ship Page
    selectGiftOptionsITS: 'checkout:shipping_select gift options',
    editGiftOptionsITS: 'checkout:shipping_edit gift options',
    shipHereITS: 'checkout:shipping_ship here',
    addNewAddressITS: 'checkout: shipping_add new address',
    changeShippingMethodITS: 'checkout:shipping_change shipping method',

    // Payment methods page
    submitPaymentMethod: 'checkout:payment methods_continue',
    openCouponField: 'checkout:payment methods_open coupon field',
    closeCouponField: 'checkout:payment methods_close coupon field',
    applyCoupon: 'checkout:payment methods_apply coupon',
    removeCoupon: 'checkout:payment methods_remove coupon',
    toggleToTapCoupon: 'checkout:payment methods_redeem member coupon',
    toggleToManualCoupon: 'checkout:payment methods_use a different coupon',
    tapToApplyCoupon: 'checkout:payment methods_tap apply coupon',

    openGiftCardFields: 'checkout:payment methods_open gift card field',
    closeGiftCardFields: 'checkout:payment methods_close gift card field',
    applyGiftCard: 'checkout:payment methods_apply gift card',
    applyGiftCardSuccess: 'checkout:payment methods_apply gift card_success',
    applyGiftCardFailure: 'checkout:payment methods_apply gift card_failure',
    removeGiftCard: 'checkout:payment methods_remove gift card',
    couponDetails: 'checkout:payment methods_open coupon details',
    selectGiftOptionsRS: 'checkout:review and submit_select gift options',
    editGiftOptionsRS: 'checkout:review and submit_edit gift options',
    openApplePay: 'checkout:review and submit_open apple pay',
    cancelApplePay: 'checkout:review and submit_cancel apple pay',

    // Review and Submit page
    submitOrder: 'checkout:review and submit_submit order',
    submitOrderSuccess: 'checkout:review and submit_submit order_success',
    submitOrderFailure: 'checkout:review and submit_submit order_failure',
    submitApplePayOrder: 'checkout:review and submit_submit apple pay order',
    couponGiftBonusCardError: 'checkout:review and submit_apply a coupon_gift or bonus card error',
    editShipment: 'checkout:review and submit_edit shipment',
    learnMoreDividendExclusions: 'checkout:review and submit_learn about dividend exclusions',
    learnMoreAboutReiTotalRewards: 'checkout:review and submit_learn about total rei rewards',
    applyTotalReiRewards: 'checkout:review and submit_apply total rei rewards',
    removeTotalReiRewards: 'checkout:review and submit_remove total rei rewards',
    addMembershipToCartReview: 'checkout:review and submit_add membership',
    removeMembershipFromCartReview: 'checkout:review and submit_remove membership',
    attachMemberNumberReview: 'checkout:review and submit_attach your member number',
    creditCardEditReview: 'checkout:review and submit_credit card edit',
    signInAsMember: 'checkout:review and submit_sign in as member',
    linkYourMembership: 'checkout:review and submit_link_your_membership',
    cobrandLink: 'checkout:review and submit_cobrand link',

    // Order confirmation page
    logout: 'checkout:order confirmation_logout',
    donateToFund: 'checkout:order confirmation_donate on REIFund.org',
    donateLearnMore: 'checkout:order confirmation_learn more REIFund.org',
    viewAccount: 'checkout:order confirmation_view and manage account',
    createAccount: 'checkout:order confirmation_create account',
    accountCreationSuccess: 'checkout:order confirmation_account created',
    accountCreationFailureDefault: 'checkout:order confirmation_account creation failed',
    accountCreationFailureExists: 'checkout:order confirmation_account exists',

    whereAreMyRewardsModal: 'checkout:review and submit_expecting to see total rewards',

  },

  page: {
    membership: 'checkout:membership',
    membershipAttached: 'checkout:membership_attached',
    billing: 'checkout:billing',
    contact: 'checkout:contact info',
    'contact-billing': 'checkout:contact and billing',
    shipping: 'checkout:shipping',
    pickup: 'checkout:pickup',
    summary: 'checkout:review and submit',
    confirmation: 'checkout:order confirmation',
  },

  pageDescription: {
    membership: 'membership',
    membershipAttached: 'membership_attached',
    billing: 'billing',
    contact: 'contact info',
    'contact-billing': 'contact and billing',
    shipping: 'shipping',
    pickup: 'pickup',
    summary: 'review and submit',
    confirmation: 'order confirmation',
  },

  isLoggedInTrue: 'logged in',
  isLoggedInFalse: 'not logged in',
  member: 'member',
  nonMember: 'non-member',

  getStandardPageViewData: () => ({
    siteId: 'rei',
    templateType: 'checkout',
    contentType: 'commerce',
  }),
}
